"use client";

import { useExploreRoute } from "../_lib/explore-route-context";
import type { ExplorePromptCard } from "../types";
import { PromptCard } from "./prompt-card";
import { SectionHeader } from "./section-header";

interface PromptsSectionProps {
  prompts: ExplorePromptCard[];
  className?: string;
}

export function PromptsSection({ prompts, className }: PromptsSectionProps) {
  const { exploreBase } = useExploreRoute();

  return (
    <section className={className}>
      <SectionHeader
        seeAllHref={`${exploreBase}/stories?type=prompt`}
        seeAllLabel="Browse all prompts →"
        title="Prompt of the day"
      />

      <div className="sm:-mx-3 grid gap-6 sm:grid-cols-2 sm:p-3">
        {prompts.map((prompt) => (
          <PromptCard key={prompt.id} prompt={prompt} />
        ))}
      </div>
    </section>
  );
}
